"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsMobile = void 0;
var _mui = require("@ori-ui/mui");
const useIsMobile = ({
  options
} = {}) => (0, _mui.useMediaQuery)(theme => theme.breakpoints.down('sm'), options);
exports.useIsMobile = useIsMobile;
//# sourceMappingURL=useIsMobile.js.map